import * as React from "react";
import { SDK } from "../sdk";
import type { SDK as ISDK } from "../sdk";

export const SDKContext = React.createContext<{
  sdk: ISDK;
}>({
  sdk: new SDK({ baseUrl: "" }),
});
